module.exports = __webpack_public_path__ + "assets/97997332a0c9b12e08ddc793c9480467.mp3";